import {
  GoalLevel,
  GoalMetricOption,
  GoalOutcome,
  GoalPeriodType,
  GoalStatus,
} from '@amzn/aet-galactus-kit';

export interface GoalDisplay {
  readonly goalID: string;
  readonly userID: string;
  readonly userName: string;
  readonly level: GoalLevel;
  readonly metric: GoalMetricOption;
  readonly description: string;
  readonly targetValue: string;
  readonly periodType: GoalPeriodType;
  readonly periodValue: string;
  readonly createdBy: string;
  readonly status: GoalStatus;
  readonly outcome?: GoalOutcome;
  readonly coachingIDs?: string[];
  readonly justification?: string;
  readonly associate?: string;
  readonly justificationTime?: string;
  readonly justificationUserName?: string;
  readonly endDate: string;
}

export const goalSortableColumns: GoalSortableColumns = {
  Associate: 'associate',
  GoalID: 'goalID',
  UserID: 'userID',
  UserName: 'userName',
  Level: 'level',
  Metric: 'metric',
  Description: 'description',
  TargetValue: 'targetValue',
  PeriodType: 'periodType',
  PeriodValue: 'endDate',
  CreatedBy: 'createdBy',
  Status: 'status',
  Outcome: 'outcome',
  Coaching: 'coachingIDs',
};

export type GoalSortableColumns = {
  Associate: string;
  GoalID: string;
  UserID: string;
  UserName: string;
  Level: string;
  Metric: string;
  Description: string;
  TargetValue: string;
  PeriodType: string;
  PeriodValue: string;
  CreatedBy: string;
  Status: string;
  Outcome: string;
  Coaching: string;
};
